<template>
  <NavbarLayout />
  <v-main>
    <div
      class="grid grid-cols-2"
      id="content"
      v-if="$route.path !== '/login/isafe'"
    >
      <CarouselComponent />
      <div class="flex flex-col items-center justify-center">
        <v-form
          ref="formData"
          class="w-2/3 lg:w-1/2"
          @submit.prevent="clickLogin"
        >
          <img
            src="../../assets/images/borneo-indobara.png"
            alt="logo borneo indobara"
            class="h-10 w-auto"
          />
          <h3 class="text-red-800 font-bold text-3xl mt-5">
            {{ verificationOtp ? "Masukkan Kode OTP" : "Masuk" }}
          </h3>
          <p class="font-normal text-sm">
            {{
              verificationOtp
                ? "Kode OTP telah dikirimkan ke email"
                : "Silahkan masukkan E-mail Anda pada kolom yang tersedia di bawah ini"
            }}
          </p>
          <template v-if="!verificationOtp">
            <div class="flex items-center gap-1">
              <label class="text-sm font-medium text-gray-500 mt-1">
                Email
              </label>
              <img
                src="../../assets/icons/Spinner-1s-200px.svg"
                class="w-6 h-auto"
                alt=""
                v-if="loadingOtp == true"
              />
            </div>
            <v-text-field
              variant="outlined"
              color="#475569"
              density="compact"
              hide-details="auto"
              placeholder="Masukkan email anda"
              :rules="formValidasi.email"
              v-model="formData.email"
            >
            </v-text-field>
            <v-btn
              variant="text"
              class="capitalize w-full text-sm font-medium bg-red-600 text-white mt-3"
              id="btn-login"
              :loading="loadingOtp"
              @click="clickLogin"
            >
              Masuk
            </v-btn>
            <v-btn
              variant="outlined"
              class="capitalize w-full text-sm font-medium mt-3 text-slate-800"
              id="btn-isafe"
              color="#475569"
              @click="clickLoginISafe"
            >
              <img
                src="../../assets/isafe_logo_icon.webp"
                alt="icon isafe"
                class="mr-2 h-4 w-auto"
              />
              Login iSafe
            </v-btn>
          </template>
          <template v-else>
            <p class="font-medium text-sm text-gray-500 mt-1">
              {{ formData.email }}
            </p>
            <div class="flex justify-start">
              <v-otp-input
                focus-all
                base-color="#475569"
                class="-mt-3 -ml-2"
                v-model="formData.otp"
                length="6"
                @finish="onOtpComplete"
              ></v-otp-input>
            </div>
            <p class="font-normal text-sm mt-1">Silahkan masukkan Kode OTP</p>
          </template>
        </v-form>
        <div class="w-2/3 lg:w-1/2" v-if="!verificationOtp">
          <div class="flex items-center justify-center w-full my-5 gap-4">
            <hr class="bg-gray-300 h-[1px] w-full" />
            <span class="text-gray-500 font-medium text-xs">Atau</span>
            <hr class="bg-gray-300 h-[1px] w-full" />
          </div>
          <v-btn
            variant="outlined"
            class="capitalize w-full text-sm font-medium text-slate-800"
            id="btn-iam"
            color="#475569"
            @click="doLoginWithGoogle"
          >
            Login with IAM
          </v-btn>
        </div>
      </div>
    </div>
    <div
      class="flex justify-center items-center h-[calc(100vh-120px)]"
      id="content-isafe"
      v-else
    >
      <div
        class="w-1/2 lg:w-1/3 2xl:w-1/4 h-auto bg-white shadow p-10 rounded flex flex-col items-center"
      >
        <img
          src="../../assets/images/logo-sinisaja.png"
          alt="logo-icon"
          class="h-auto w-28"
          loading="lazy"
        />
        <p class="font-medium text-sm text-gray-500 text-center mt-2">
          Gunakan username dan password dari
          <span class="text-gray-600">iSafe</span>
        </p>
        <v-form ref="formDataISafe" class="w-full mt-7">
          <label for="label" class="text-sm font-medium text-gray-500 mb-1">
            iSafe No
          </label>
          <v-text-field
            variant="outlined"
            color="#475569"
            density="compact"
            hide-details="auto"
            placeholder="Masukkan iSafe number anda"
            :rules="formValidasiISafe.iSafeNo"
            v-model="formDataISafe.iSafeNo"
          >
          </v-text-field>
          <label
            for="label"
            class="text-sm font-medium text-gray-500 mb-1 mt-3"
          >
            Password
          </label>
          <v-text-field
            variant="outlined"
            color="#475569"
            :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
            :type="visible ? 'text' : 'password'"
            density="compact"
            hide-details="auto"
            placeholder="Masukkan password anda"
            :rules="formValidasiISafe.password"
            v-model="formDataISafe.password"
            @click:append-inner="visible = !visible"
          >
          </v-text-field>

          <v-btn
            variant="text"
            class="capitalize w-full text-sm font-medium bg-red-600 text-white mt-5"
            id="btn-login"
            :loading="loadingLogin"
            @click="onLogin"
          >
            Masuk
          </v-btn>

          <div
            class="flex justify-between items-center mt-4 text-xs font-medium text-gray-500"
          >
            <h5 class="cursor-pointer">Term of Service</h5>
            <h5 class="cursor-pointer">Privacy Policy</h5>
            <h5 class="cursor-pointer">Contact Us</h5>
          </div>
        </v-form>
      </div>
    </div>
  </v-main>
  <FooterLayout />
</template>

<style scoped>
#content {
  background: #ffffff url("@/assets/images/bg_infokontraktor.png") no-repeat;
  background-position: right 0rem top -1rem;
}
#content-isafe {
  background: url("../../assets/images/Background\ Landing\ Page.png") no-repeat
    center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>

<script>
import axios from "axios";
import { API_BASE_URL, APP_VERSION } from "@/constants";
import router from "@/router";
import FooterLayout from "@/layouts/FooterLayout.vue";
import NavbarLayout from "@/layouts/NavbarLayout.vue";
import CarouselComponent from "./components/CrouselComponent.vue";
import {
  FormDataAuth,
  FormDataISafeAuth,
  FormValidasitonAuth,
  FormValidationISafeAuth,
} from "./core/FormData";
import { cloneDeep } from "lodash";
import util from "@/assets/js/util";
import { getKeycloak, initKeycloak } from "@/config/keyclock";
import { levelEnum } from "@/utilities/enum";
import { getSimperDynamic } from "@/utilities/ESBE";

export default {
  name: "LoginPage",
  components: { NavbarLayout, FooterLayout, CarouselComponent },
  data() {
    return {
      formValidasi: FormValidasitonAuth,
      formValidasiISafe: FormValidationISafeAuth,
      formData: cloneDeep(FormDataAuth),
      formDataISafe: cloneDeep(FormDataISafeAuth),
      verificationOtp: false,
      loadingOtp: false,
      loadingLogin: false,
      visible: false,
      AccessToken: "",
      keycloak: null,
      levelEnum,
    };
  },
  mounted() {
    if (!getKeycloak()) {
      this.keycloak = initKeycloak();
    }

    const hash = window.location.hash;
    if (hash.includes("state=") && hash.includes("code=")) {
      this.doLoginWithGoogle();
    }
  },
  methods: {
    async clickLogin() {
      if (this.loadingOtp) return;
      const validate = await this.$refs.formData.validate();
      if (validate.valid) {
        try {
          await this.onSendRequestGetOTP();
          this.verificationOtp = true;
        } catch (err) {
          this.verificationOtp = false;
          util.showError(err);
        }
      }
    },
    async onSendRequestGetOTP() {
      this.loadingOtp = true;
      try {
        await axios.post(`${API_BASE_URL}cms/grant/kontraktor`, {
          email: this.formData.email,
          headerDTO: null,
        });
        return Promise.resolve();
      } catch (err) {
        if (err.code == "ERR_NETWORK") {
          util.showError(
            "Jaringan tidak terhubung. Silahkan coba beberapa saat lagi.",
            5000,
          );
        } else {
          if (err.response.status == 401) {
            util.showError("Kontraktor tidak ditemukan!", 5000);
          } else {
            util.showError("Terjadi kesalahan! Permintaan OTP Gagal", 5000);
          }
        }
        setTimeout(() => {
          this.loadingOtp = false;
        }, 500);
        return Promise.reject(err);
      } finally {
        setTimeout(() => {
          this.loadingOtp = false;
        }, 500);
      }
    },
    async onOtpComplete() {
      try {
        const res = await axios.post(`${API_BASE_URL}cms/grant/otp`, {
          email: this.formData.email,
          otp: this.formData.otp,
        });

        const userData = {
          token: res.data.token,
          kontraktorName: res.data.claims.kontraktorName,
          email: this.formData.email,
          role: res.data.claims.profileName,
          kontraktorID: res.data.claims.id,
          userId: res.data.claims.userId,
          gemsCode: res.data.claims.gemsCode,
          inisial: res.data.claims.inisial,
          workArea: res.data.claims.workArea,
          isPjo: res.data.claims.isPjo,
          id: res.data.claims.id,
          name: res.data.claims.name,
          department: res.data.claims.department,
          app_version: APP_VERSION,
        };

        localStorage.setItem("user_cms", JSON.stringify(userData));
        if (userData.role === levelEnum.EXTERNAL) {
          router.push({
            path: "/nc-audit-iso-smk3-external-monitoring",
            query: { tab: 2 },
          });
        } else {
          router.push({ path: "dashboard" });
        }
        util.showInfo("Login berhasil!", 2000);
      } catch (err) {
        this.formData.otp = null;
        if (err.response.status == 401) {
          util.showError("Kode OTP Salah! Silahkan Coba kembali.");
        } else {
          util.showError(err.response.data.status.message);
        }
      }
    },
    clickLoginISafe() {
      router.push({ path: "/login/isafe" });
    },
    async onLogin() {
      if (this.loadingLogin) return;
      const validate = await this.$refs.formDataISafe.validate();
      if (validate.valid) {
        this.loadingLogin = true;
        try {
          const res = await axios.post(`${API_BASE_URL}cms/grant/isafe`, {
            isafeNo: this.formDataISafe.iSafeNo,
            password: this.formDataISafe.password,
          });

          const userData = {
            token: res.data.token,
            kontraktorName: res.data.claims.kontraktorName,
            email: res.data.claims.email,
            role: res.data.claims.role,
            userId: res.data.claims.userId,
            inisial: res.data.claims.inisial,
            workArea: res.data.claims.workArea,
            name: res.data.claims.name,
            isPjo: res.data.claims.isPjo,
            id: res.data.claims.id,
            department: res.data.claims.department,
            app_version: APP_VERSION,
            isafe_no: res.data.claims.id,
          };

          const user = await this.getUserIcore({
            isafeNo: this.formDataISafe.iSafeNo,
          });
          const company = user.company
            ?.replace(/^(PT|CV)\s*/i, "")
            .toUpperCase();
          userData.kontraktorName = company;

          localStorage.setItem("user_cms", JSON.stringify(userData));

          if (userData.role.includes("IMPROVEMENT")) {
            router.push({ path: "dashboard-esg" });
          } else {
            router.push({ path: "dashboard" });
          }
          util.showInfo("Login berhasil!", 2000);
        } catch (err) {
          console.log({ err });
          if (err?.response?.status === 401) {
            util.showError("Username atau password salah.");
          } else {
            util.showError(
              "Terjadi kesalahan, silahkan coba beberapa saat lagi.",
            );
          }
          this.loadingLogin = false;
        } finally {
          this.loadingLogin = false;
        }
      }
    },
    async doLoginWithGoogle() {
      console.log("[Login IAM] Starting Google login process");
      this.AccessToken = "Authenticating...."; // Value sementara AccessToken yang menandakan bahwa script sedang berjalan

      const keycloak = getKeycloak(); // Fetch the existing Keycloak instance

      if (!keycloak) {
        console.error("Keycloak instance not found");
        return;
      }

      keycloak
        .init({ onLoad: "login-required" })
        .then(async (auth) => {
          // menjalankan script keycloack dengan membawa parameter onload dengan value login-required
          if (!auth) {
            console.log("NOT Authenticated");
            this.AccessToken = ""; // jika autentikasi gagal makan value AccessToken di kosongkan
          } else {
            console.log("Authenticated");
            this.AccessToken = this.keycloak.token; // jika autentikasi berhasil maka mengisi variable AccessToken dengan token dari keycloack
          }
          try {
            await axios.get(
              `${process.env.VUE_APP_KEYCLOAK_URL}/realms/ugems/broker/google/token`, // jika login menggunakan google
              {
                headers: {
                  Authorization: `Bearer ${this.keycloak.token}`, // membawa headers dengan token keycloack
                },
              },
            );
          } catch (err) {
            console.log({ googleTokenErr: err });
            console.log("failed to get google token");
          }
          localStorage.setItem("ugems-accessToken", this.keycloak.token); // menyimpan data token di local storage
          localStorage.setItem(
            "ugems-refreshToken",
            this.keycloak.refreshToken,
          );
          localStorage.setItem(
            "ugems-tokenParsed",
            JSON.stringify(this.keycloak.tokenParsed),
          );
          await this.onLoginWithGoole();
        })
        .catch((err) => {
          console.error("[Login IAM] Keycloak error:", err);
          util.showError(err);
        });
    },
    async onLoginWithGoole() {
      let bodyJson = {
        ugemsAccessToken: this.keycloak.token,
        ugemsRefreshToken: this.keycloak.refreshToken,
      };

      try {
        const response = await axios.post(
          `${API_BASE_URL}cms/grant/iam`,
          bodyJson,
        );

        const res = response.data;

        const userData = {
          token: res.token,
          kontraktorName: res.claims.kontraktorName,
          role: res.claims.role,
          userId: res.claims.userId,
          inisial: res.claims.inisial,
          isPjo: res.claims.isPjo,
          name: res.claims.name,
          workArea: res.claims.workArea,
          email: res.claims.email,
          gemsCode: res.claims.gemsCode,
          id: res.claims.id,
          iam: true,
          department: res.claims.department,
          app_version: APP_VERSION,
          isafe_no: '',
        };

        const user = await this.getUserIcore({ email: userData.email });
        const company = user.company?.replace(/^(PT|CV)\s*/i, "").toUpperCase();
        userData.kontraktorName = company;
        userData.id = user.isafe_no;
        userData.isafe_no = user.isafe_no
        userData.department = user.department;

        localStorage.setItem("user_cms", JSON.stringify(userData));

        if (userData.role.includes("IMPROVEMENT")) {
          router.push({ path: "dashboard-esg" });
        } else {
          router.push({ path: "dashboard" });
        }
        util.showInfo("Login berhasil!", 2000);
      } catch (err) {
        console.error("[Login IAM] Error exchange token / grant IAM:", err);
        util.showError("Terjadi kesalahan saat login dengan IAM.");
      }
    },
    async getUserIcore({ isafeNo, email }) {
      const res = await getSimperDynamic({
        isafe_number: isafeNo,
        email: email,
        is_internal: false,
      });

      if (res.simper.length) {
        return res.simper[0];
      } else {
        return {
          company: "",
          department: null,
          isafe_no: null,
        };
      }
    },
  },
};
</script>
